"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const { rem } = ui_common_components_1.utils;
const StyledSectionVideoContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.Small)};
  `}
`;
const StyledComponent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
function Video({ autoPageNavigation = false, autoPlay = false, displayVideoControl = false, fullScreen = false, playOnLoop = false, playWithSound = false, options, onUpdate, }) {
    const [settings, setSettings] = (0, react_1.useState)({
        autoPlay,
        playWithSound,
        playOnLoop,
        fullScreen,
        displayVideoControl,
        autoPageNavigation,
    });
    const handleVideoSettings = (0, react_1.useCallback)((name, value) => {
        setSettings((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({ [name]: value });
    }, [onUpdate]);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(StyledSectionVideoContainer, { children: options.map((option, index) => {
            if (option.type === 'divider') {
                return (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {}, option.titleKey);
            }
            return ((0, jsx_runtime_1.jsxs)(StyledComponent, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: t(option.titleKey) }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Switch, { checked: option.checked, onChange: (value) => {
                            handleVideoSettings(option.name, value);
                        } })] }, `video-${index}-${option.titleKey}`));
        }) }));
}
exports.Video = Video;
//# sourceMappingURL=Video.js.map